import React, { useState, useEffect, useCallback, useContext } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { useParams } from "react-router";
import AuthHeader from "../../layout/AuthHeader";
import PoweredBy from "../../layout/PoweredBy";
import AuthenticationService from "../../../services/AuthenticationService";
import Alert from "../../Alert";
import Button from "../../Button";
import Container from "../../Container";
import Input from "../../Input";
import UpdatePassword from "../../forms/UpdatePassword";
import apiRequest from "../../../services/apiRequest";
import getRoutePath from "../../../routes/getRoutePath";
import CountryContext from "../../../CountryContext";
import { BrandingBg } from "../../../components/Brandingbg";

const ResetPassword = () => {
  const intl = useIntl();
  const { token } = useParams();
  const { country } = useContext(CountryContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    apiRequest
      .post("/users/validate", { token: token }, { publicRequest: true })
      .then((data) => {
        // setUid(data["id"]);
        setEmail(data["email"]);
      })
      .catch((err) => {
        console.error("Error:", err);
        setError("Not authorized");
      })
      .finally(() => setLoading(false));
  }, [token]);

  const submit = useCallback(
    async (e) => {
      try {
        e.preventDefault();

        if (!password || !confirmPassword || password !== confirmPassword) {
          return;
        }

        if (password.includes(" ") || password.length < 8) {
          return;
        }

        setLoading(true);
        setError("");
        await apiRequest.post(
          "/users/password/update",
          { email, password, token },
          { publicRequest: true }
        );
        try {
          await AuthenticationService.login(email, password, country.code);
          window.location = getRoutePath("/home");
        } catch (err) {
          setError(intl.formatMessage({ id: "authentication_failed" }));
        }
      } catch (error) {
        setError(intl.formatMessage({ id: "error_while_saving" }));
      } finally {
        setLoading(false);
      }
    },
    [password, email, confirmPassword, intl, token, country]
  );

  return (
    <BrandingBg bgOpacity="40">
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <Container>
          <AuthHeader title={intl.formatMessage({ id: "update_password" })} variant="white" />

          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
              <form action="#" method="POST" onSubmit={submit}>
                <div>
                  <Input
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    label="Email"
                    type="email"
                    disabled
                  />
                </div>

                <UpdatePassword
                  password={password}
                  setPassword={setPassword}
                  confirmPassword={confirmPassword}
                  setConfirmPassword={setConfirmPassword}
                />

                <div>
                  <Button
                    full
                    type="submit"
                    submitting={loading}
                    disabled={!password || !confirmPassword || password !== confirmPassword}
                  >
                    <FormattedMessage id="confirm" />
                  </Button>
                </div>
                {error ? (
                  <div className="mt-4">
                    <Alert slim type="error" title={error} />
                  </div>
                ) : null}
              </form>
            </div>
            <div className="filter invert">
              <PoweredBy />
            </div>
          </div>
        </Container>
      </div>
    </BrandingBg>
  );
};

export default ResetPassword;
